import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=c40fdfce&scoped=true&"
import script from "./Policies.vue?vue&type=script&lang=js&"
export * from "./Policies.vue?vue&type=script&lang=js&"
import style0 from "./Policies.css?vue&type=style&index=0&id=c40fdfce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40fdfce",
  null
  
)

export default component.exports